// Themes from https://github.com/NatEvatt/awesome-mapbox-gl-styles
import type { StyleSpecification } from "maplibre-gl";
import darkMatterTheme from "./dark_matter.json";
import gtaTheme from "./gta_theme.json";
import n4sTheme from "./n4s.json";
import neonTheme from "./neon.json";
import swissSkiTheme from "./swiss_ski.json";
import vintageTheme from "./vintage.json";
import whaamTheme from "./whaam.json";

type RawTheme = StyleSpecification & { name?: string };

function register(id: string, raw: unknown) {
  const theme = raw as RawTheme;
  return { id, name: theme.name ?? id, style: theme };
}

// To add a new theme: import the JSON and add a register() call to this array.
export const mapThemes = [
  register("dark_matter", darkMatterTheme),
  register("n4s", n4sTheme),
  register("gta", gtaTheme),
  register("whaam", whaamTheme),
  register("swiss_ski", swissSkiTheme),
  register("vintage", vintageTheme),
  register("neon", neonTheme),
];
